module.exports = __webpack_public_path__ + "img/car-stuck.44f0b8cc.jpg";